import { config } from '../config/config'
import { useUserStore } from '../stores/user-session.store'
import { refreshUser } from './token-manager'

let refreshTimer: ReturnType<typeof setInterval> | null = null

export function startTokenRefreshScheduler(): () => void {
  if (refreshTimer) return stopTokenRefreshScheduler

  refreshTimer = setInterval(() => {
    void refreshUser().catch((error) => {
      useUserStore.getState().onRefreshTokenError?.(error)
    })
  }, config.getRefreshIntervalMs())

  return stopTokenRefreshScheduler
}

export function stopTokenRefreshScheduler(): void {
  if (!refreshTimer) return

  clearInterval(refreshTimer)
  refreshTimer = null
}

export function isTokenRefreshSchedulerRunning(): boolean {
  return refreshTimer !== null
}
